import React from "react";
import Slide from "@material-ui/core/Slide";

class Transition extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return <Slide direction="up" {...this.props} />;
  }
}

export default Transition;